export default {
    myInterests: "/gateway/huilianCust/hcCustInterestscs/myInterests",
    applyHcWelfareConsume:
        "/gateway/huilianCust/hcWelfareConsumecs/applyHcWelfareConsume",
};



// WEBPACK FOOTER //
// ./src/interestsConfig/api.js